import React, { Component, PropTypes } from 'react'
import { connect } from 'react-redux'
import TextareaAutosize from 'react-textarea-autosize'
import { updateCommentBemDoc } from 'state/actions'
import styles from './UploaderTableComment.scss'

@connect(null)
export class UploaderTableComment extends Component {
    constructor(props) {
        super(props)
        this.state = {
            ...this.resolveDocumentComment(props.document),
            hideCancel: true,
            timeoutId: null,
        }
    }

    componentWillUnmount() {
        const { timeoutId } = this.state
        if (timeoutId) {
            clearTimeout(timeoutId)
        }
    }

    /**
     * Resolve the document comment field based on the document structurture.
     * @param {object} file claim | client | contract | tarification
     * @returns {object} { commentKey: string | null, commentValue: string}
     */
    resolveDocumentComment= (file) => {
        let commentValue = ''
        let commentKey = null
        const commentKeys = ['clientDocumentBemComment', 'contractDocumentBemComment', 'tarificationDocBemComment', 'documentBemComment']
        commentKeys.forEach((key) => {
            if (Object.prototype.hasOwnProperty.call(file, key)) {
                commentKey = key
                commentValue = file[key]
                return
            }
        })
        return { commentKey, commentValue }
    }

    handleChangeComment = (event) => {
        if (event) {
            this.setState({ commentValue: event.target.value })
        } else {
            this.setState({ commentValue: '' })
        }
    }

    handleFocusComment = () => {
        this.setState({ hideCancel: false })
    }

    handleBlurComment = () => {
        const { document } = this.props
        const { commentKey, commentValue } = this.state

        if (document[commentKey] !== commentValue) {
            this.dispatchUpdateComment(commentValue)
        }

        const timeoutId = setTimeout(() => { // delay to allow click on cancel button
            this.setState({ hideCancel: true })
        }, 100)

        this.setState({ timeoutId }) // save timeoutId to clear it on component unmount
    }

    handleClearComment = (event) => {
        event.stopPropagation()
        this.setState({ commentValue: '', hideCancel: true})
        this.dispatchUpdateComment('')
    }

    dispatchUpdateComment = (commentValue) => {
        const { dispatch, document, typeId, uploadId, uploadType } = this.props
        const { commentKey } = this.state
        dispatch(updateCommentBemDoc({
            documentId: document.documentId, // might be `undefined` if adding comment to the document (not file document)
            bemComment: { commentValue, commentKey },
            uploadId,
            typeId,
            uploadType,
        }))
    }

    render() {
        const { commentKey, commentValue, hideCancel } = this.state

        if (!commentKey) {
            return <div style={{height: 33}}></div> // empty div to keep the same height as the other rows
        }

        return (
            <div className={styles.userCommentContainer}>
                <TextareaAutosize
                    maxRows={4}
                    placeholder=""
                    maxLength="2000"
                    value={commentValue}
                    name="user_comment_textarea"
                    onChange={this.handleChangeComment}
                    onFocus={this.handleFocusComment}
                    onBlur={this.handleBlurComment}
                    className={styles.userCommnetField}
                />
                {commentValue &&
                    <button
                        type="button"
                        onClick={this.handleClearComment}
                        style={{
                            opacity: hideCancel ? 0 : 1,
                            pointerEvents: hideCancel ? 'none' : 'auto',
                        }}
                        className={styles.removeInput}
                    >
                        <span className={styles.cross}>&times;</span>
                    </button>
				}
            </div>
        )
    }
}
UploaderTableComment.propTypes = {
    dispatch: PropTypes.func,
    typeId: PropTypes.string,
    uploadId: PropTypes.string,
    uploadType: PropTypes.string, // 'claim' | 'client' | 'contract' | 'tarification'
    document: PropTypes.object,
}



// WEBPACK FOOTER //
// ./components/uploader/UploaderTableComment.jsx